// import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
// import 'bootstrap/dist/js/bootstrap.bundle.min'; mani
import $ from 'jquery';

var jQuery = $;
// import 'popper.js';


function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
	var ret = [];
	for (var i = 0; i < n; i++)
		ret.push(v instanceof Object ? clone(v) : v);
	return ret;
}

function bool(s) {
	if (typeof (s) == 'boolean') return s;
	if (!defined(s) || s === null) return false;
	if (typeof (s) == 'number') return s > 0;
	if (s.match(/^y/i)) return true;
	return false;
}

function sbool(v) {
	return ['No', 'Yes'][v];
}

function ckEmail(v) {
	return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v);
}

function aLast(a) { return a.length ? a[a.length - 1] : null }

function aUnique(a) {
	var h = {};
	function has(v) {
		var r = !(v in h);
		h[v] = 1;
		return r;
	}
	return a.filter(i => has(i))
}


async function runAll(arr, each, done) {

	for (var i = 0; i < arr.length; i++) {
		let promise = new Promise((resolve, reject) => {
			each(arr[i], resolve)
		});
		await promise;
	}
	done();
}


function myAlertOld(title, message, btn, callback, btn2, callback2, btn3, callback3) {
	if (window.$("#myModal").hasClass('show')) {
		return setTimeout(function () {
			myAlert(title, message, btn, callback, btn2, callback2, btn3, callback3)
		}, 1000);
	}
	$('.modal-title').html(title);
	$('.modal-body').html(message);
	window.$("#myModal").modal({
		backdrop: 'static',
		keyboard: false,
	})
	$(".myclose").css({ position: 'absolute', right: px(10), top: px(0) }).hide();
	$("#modal-close2").hide();
	$("#modal-close3").hide();
	if (!btn) btn = 'Ok';
	if (btn) $("#modal-close").html(btn).show();

	$('.modal-footer').show();
	if (callback) $("#modal-close").off('click').on('click', callback);
	if (btn2) {
		$("#modal-close2").html(btn2);
		$("#modal-close2").show();
	}
	if (callback2) $("#modal-close2").off('click').on('click', callback2);
	if (btn3) {
		$("#modal-close3").html(btn3);
		$("#modal-close3").show();
	}
	if (callback3) $("#modal-close3").off('click').on('click', callback3);
}

function myAlert(title, body, btn, callback, btn2, callback2, btn3, callback3) {
	$('.modal-header').show();
	$('.modal-title').html(title);
	$('.modal-title').css({
		"white-space": "nowrap",
		"overflow": "hidden",
		"text-overflow": "ellipsis"
	});
	
	var modal = window.$("#myModal");
	if (typeof (body) == 'string') $('.modal-body').html(body);
	else $('.modal-body').html('').append(body);
	modal.modal({
		backdrop: 'static',
		keyboard: false,
	});

	$('#myTextarea').css({ border: '1px solid #c3c3c3'})

	modal.off('Shown.bs.modal').on('Shown.bs.modal', function () {
		alert('shown')
	})
	modal.find(".myclose").css({ position: 'absolute', right: px(10), top: px(0) }).hide();
	// modal.find("#modal-close2").hide();
	modal.find(".btn").hide();
	modal.find('.btn-primary').removeClass('btn-primary');
	modal.find('.btn-secondary').removeClass('btn-secondary');
	modal.find('.btn-danger').removeClass('btn-danger');

	function setButton(id, label, callback) {
		var bid = '#modal-close' + (id || '');
		var but = modal.find(bid);
		if (!label) label = '';
		var isDanger = label.match(/^\*/);
		var isPrimary = label.match(/^\^/);
		if (isPrimary) but.addClass('btn-primary')
		else if (isDanger) but.addClass('btn-danger')
		else but.addClass('btn-secondary');
		label = label.replace(/^[\^\*]/, '');
		but.html(label);
		if (label) but.show();
		else but.hide();
		but.off('click')
		if (callback) but.on('click', callback);
	}
	if (!btn) btn = 'Ok';
	modal.find('button').removeAttr('disabled');
	setButton('', btn, callback);
	setButton(2, btn2, callback2);
	setButton(3, btn3, callback3);
	$('.modal-dialog').css({ maxWidth: '' })
	$('.modal-backdrop').css({ zIndex: 10000 })
}

function expandSection(target) {
	let b = $('button[data-target="#' + target + '"][aria-expanded="false"]');
	if (b.length) b[0].click();
}

function collapseSection(target) {
	let b = $('button[data-target="#' + target + '"][aria-expanded="true"]');
	if (b.length) b[0].click();
}



function myInput(title, message, value, confBtn, cancelBtn, callback) {

	let _p_callback = callback;
	return new Promise(async (resolve, reject) => {
		let callback = function () {
			if (_p_callback) _p_callback.apply(this, arguments);
			resolve.apply(this, arguments);
		}
		let amessage = message;
		amessage += '<br><textarea id="_confirm_input" autocomplete="off" class="mt-2 mb-4 form-control"></textarea>';
		myAlert(title, amessage, confBtn || 'Ok', ckConfirm, cancelBtn || 'Cancel', function () { callback(null) });
		$('#_confirm_input').val(value || '');
		setTimeout( function(){
			$('#_confirm_input')[0].focus();
		}, 500 )
		async function ckConfirm(ev) {
			removeInlineErrors();
			ev.preventDefault();
			ev.stopPropagation();
			let input = $('#_confirm_input').val().trim();
			if (!input) {
				inlineError($('#_confirm_input'), 'Input required')
				$('#_confirm_input')[0].focus();
				return 
			} 
			myAlertClose(() => {
				callback(input)
			})
		}
	});
}



function myConfirm(title, message, confText, confBtn, cancelBtn, callback) {

	let _p_callback = callback;
	return new Promise(async (resolve, reject) => {
		let callback = function () {
			if (_p_callback) _p_callback.apply(this, arguments);
			resolve.apply(this, arguments);
		}
		let amessage = message;
		if (confText) amessage += '<br><input placeholder="type \'' + confText + '\' to confirm" type="text" id="_confirm_input" autocomplete="off" class="mt-2 mb-4 form-control">';
		myAlert(title, amessage, confBtn || 'Ok', ckConfirm, cancelBtn || 'Cancel', function () { callback(false) });
		function ckConfirm(ev) {
			if (!confText || $('#_confirm_input').val().trim().toLowerCase() == confText) {
				myAlertClose(() => {
					callback(true)
				})
			}
			else {
				$('#_confirm_input')[0].focus();
				ev.preventDefault();
				ev.stopPropagation();
			}
		}
		if (confText) {
			function ckDis() {
				var dis = confText && $('#_confirm_input').val().trim().toLowerCase() != confText
				$('#modal-close').attr('disabled', dis)
			}
			$('#_confirm_input').on('keyup', (ev) => {
				if (ev.keyCode == 13) ckConfirm(ev);
				ckDis();
			})
			ckDis();
			setTimeout(function () {
				$('#_confirm_input')[0].focus()
			}, 500)
		}
	});

}

function myAlertClose(callback) {
	let _p_callback = callback;
	return new Promise(async (resolve, reject) => {
		let callback = function () {
			if (_p_callback) _p_callback.apply(this, arguments);
			resolve.apply(this, arguments);
		}
		try {
			// console.log('myAlertClose', window.$("#myModal").data('bs.modal')._isTransitioning, window.$("#myModal").data('bs.modal')._isShown)
			// if( !window.$("#myModal").data('bs.modal')._isShown && !window.$("#myModal").prop('retryClose') ) {
			// 	window.$("#myModal").prop('retryClose', true );
			// 	console.log( 'myAlerCloseWait')
			// 	return setTimeout( function(){
			// 		myAlertClose(callback);
			// 	})
			// }
			// window.$("#myModal").prop('retryClose', false );
			if (!window.$("#myModal").is(':visible')) return callback();
			if (window.$("#myModal").data('bs.modal')._isTransitioning) {
				return setTimeout(function () {
					myAlertClose(callback)
				}, 300)
			}
			if (callback && typeof (callback) == 'function') {
				window.$('#myModal').on('hidden.bs.modal', function (ev) {
					window.$('#myModal').off('hidden.bs.modal');
					callback(ev);
				});
			}
			setTimeout(function () {
				window.$('#myModal').modal('hide');
			}, 10);
		}
		catch (e) {
			// console.error(e)
		}
	});
}

/*
 * Add an inline error right after the hook DOM element
 */

var inlineErrorFocus = null;
function inlineError(hookElement, errorMessage) {
	let errDiv = $('<div>').addClass('form-warning').html(errorMessage);
	let hookmb = hookElement.css('margin-bottom');
	if (hookmb) errDiv.css({ marginTop: '-' + hookmb })
	hookElement.after(errDiv);
	if (!inlineErrorFocus) {
		inlineErrorFocus = hookElement;
		setTimeout(function () {
			try {
				if (hookElement && hookElement.length) hookElement[0].focus();
			}
			catch (e) { }
		}, 500);
	}
	return true;
}

/*
 * Remove all inline errors from screen
 */

function removeInlineErrors() {
	inlineErrorFocus = null;
	$('.form-warning').remove();
}

function paletteWheel(div, brightness) {
	if (!brightness) brightness = 1;
	var steps = [[255, 0, 0], [0, 255, 0], [0, 0, 255], [255, 0, 0]];
	var colors = [];
	function interpolate(v) {
		v *= steps.length - 1;
		var i = Math.floor(v);
		var r = v - i;
		var ir = 1 - r;
		// console.log( 'v', v, 'i', i, 'r', r );
		return [steps[i][0] * ir + steps[i + 1][0] * r, steps[i][1] * ir + steps[i + 1][1] * r, steps[i][2] * ir + steps[i + 1][2] * r];
	}
	for (var d = 0; d < div; d++) {
		var c = interpolate(d / div).map(v => {
			return brightness < 1 ? v * brightness : Math.min(v + 128 * (brightness - 1), 255)
		})
		var hc = '#' + c.map(v => Math.floor(v).toString(16).padStart(2, '0')).join('');
		colors.push(hc);
	}
	return colors;
}

function inputTitles() {
	let inputs = Array.from($('input'));
	for (let inpt of inputs) {
		if (inpt.placeholder > '') $(inpt).attr('title', inpt.placeholder)
	}
}

var lastFields = {};
function booleanList(hook, source, opts, callback) {
	// console.log( 'bool', opts.items )
	var init = true;
	if (!source) source = {};
	if (!opts) opts = {};
	var initValues = opts.initValues || 5;
	var pcolors = paletteWheel(initValues);
	var colorIdx = 0;
	if (!opts.maxSubLabels) opts.maxSubLabels = 3;
	hook.html('');
	var obj = $('<DIV>').addClass('option-list');
	hook.append(obj);

	var output = {};
	lastFields = {};
	function setNext(key, val) {
		if (lastFields[key]) {
			lastFields[key].prop('next', val);
			val.prop('prev', lastFields[key]);
		}
		lastFields[key] = val;
	}

	function fieldKeyDown(ev) {
		// console.log( 'keyCode', ev.keyCode, ev )
		if (ev.keyCode == 9 && ev.shiftKey) {
			this.blur();
			var nx = $(ev.target).prop('prev');
			if (nx) nx.focus();
			ev.preventDefault();
		}
		else if ((ev.target.tagName == 'INPUT' && ev.keyCode == 13) || ev.keyCode == 9) {
			this.blur();
			var nx = $(ev.target).prop('next');
			if (nx) nx.focus();
			ev.preventDefault();
		}
	}

	function change() {
		if (callback && !init) callback(output);
	}

	var nItems = 0;
	var ckwid = 0;
	for (var f in opts.items) {
		var it = opts.items[f];
		var opt = $('<DIV>').addClass('option-item').addClass(f);
		obj.append(opt);
		output[f] = defined(source[f]) ? source[f] : (it.default || false);
		// console.log( 'f', f, source[f], output[f], it.default )

		var cont = $('<SPAN>').addClass('option-boolean');
		var ofield = $('<INPUT type="checkbox">').text('color').prop('checked', output[f]).prop('label', f);
		var k = f;
		ofield.on('change', function () { output[$(this).prop('label')] = $(this).prop('checked'); change(); })
		ofield.on('keydown', fieldKeyDown);
		ofield.change();
		setNext(f, ofield);
		cont.append(ofield);
		opt.append(cont);
		var h = $('<DIV>').text(it.label || f).addClass('option-boolean-label').prop('ck', ofield);
		h.on('click', function () { $(this).prop('ck').click(); })
		opt.append(h);
		if (!ckwid) ckwid = cont.outerWidth();
		nItems++;
	}
	if (nItems > 1 || opts.forceHeader) {
		var hLabels = opts.header || ['', 'Attribute'];
		var opt = $('<DIV>').addClass('option-item').addClass('option-header-bar');
		obj.prepend(opt);
		var h = $('<DIV>').text(hLabels[0]).addClass('option-header').css({ width: ckwid });
		opt.append(h);
		var h = $('<DIV>').text(hLabels[1]).addClass('option-header');
		opt.append(h);
	}
	if (nItems == 0) obj.hide();
	init = false;
	if (opts.callbackOnInit) change();
	if( Object.keys(opts.items).length == 1 && !opts.header ) {
		// console.log( 'single', opts )
		obj.find('input[type=checkbox]').css({marginLeft:0})
	}
}

function colOptName(f) {
	return 'opt_' + f.replace(/[^a-z]/i, '_');
}

var outTid = null;
var emptyField = null;

function optionList(hook, source, opts, callback) {
	// console.log( '>>>>>>>>>>>>>>>>>>>>>>>>>>', source )
	if (!source) source = {};
	if (!opts) opts = {};
	var initValues = opts.initValues || 10;
	var pcolors = paletteWheel(initValues);
	var colorIdx = 0;
	if (!opts.maxSubLabels) opts.maxSubLabels = 3;
	hook.html('');
	var obj = $('<DIV>').addClass('option-list');
	hook.show();
	hook.append(obj);
	var olist = [];
	
	var lastFields = {};
	var fieldNames = Object.keys(opts.fields);
	var fieldKey = opts.fieldKey || fieldNames[0];
	var fieldDefault = opts.defaultField || fieldNames[1];
	if( opts.arrayOutput || isarray(source) ) {
		if( isarray(source) ) {
			let ns = {};
			for( let s of source ) {
				ns[s[opts.fieldKey]] = s;
				delete s[opts.fieldKey];
			}
			source = ns;
		}
	}

	function cmd(c, idx) {
		// console.log('cmd', c, idx, olist[idx], opts);
		if (opts.arrowCheck && !opts.arrowCheck(olist, c, idx)) return;
		// if (c == 'right' && olist[idx].level < opts.maxSubLabels && olist[idx - 1].level >= olist[idx].level && olist[idx - 1].key) {
			if (
				c === 'right' &&
				idx > 0 && // Ensure idx - 1 is within bounds
				idx < olist.length && // Ensure idx is within bounds
				olist[idx]?.level < opts.maxSubLabels && // Check if olist[idx] exists and level is valid
				olist[idx - 1]?.level >= olist[idx]?.level && // Check if olist[idx - 1] exists and level is valid
				olist[idx - 1]?.key // Ensure olist[idx - 1].key exists
			) {
		olist[idx].level++;
			draw();
			change();
		}
		if (c == 'left' && olist[idx].level > 0) {
			olist[idx].level--;
			draw();
			change();
		}
		if (c == 'add') {
			emptyField = null;
			setTimeout(function () {
				if (emptyField) emptyField.focus();
			}, 200)

			olist.splice(idx + 1, 0, { key: '', value: {}, level: olist[idx].level })
			draw();
			change();
		}
		if (c == 'del') {
			olist.splice(idx, 1);
			draw();
			change();
		}
		if (c == 'up' && idx > 0) {
			var tmp = olist[idx];
			olist.splice(idx, 1);
			olist.splice(idx - 1, 0, tmp);
			draw();
			change();
		}
		if (c == 'down' && idx < olist.length - 1) {
			var tmp = olist[idx];
			olist.splice(idx, 1);
			olist.splice(idx + 1, 0, tmp);
			draw();
			change();
		}
	}

	var lastName = null;
	var lastAlias = null;


	var optWidths = [];
	function addOpt(key, value, level, idx) {
		// console.log( 'addOpt', key, value, level, idx )
		if (!level) level = 0;
		if (isstring(value)) value = {};

		var opt = $('<DIV>').addClass('option-item');
		obj.append(opt);
		function setField(f, v, obj) {
			if (f == fieldKey) {
				// v = v.trim().replace(/\./g,'_').replace(/^\$/,'_')
				v = v.trim()
				olist[idx].key = v;
				if( obj ) obj.val(v)
			}
			else olist[idx].value[f] = v;
		}
		function getField(f) {
			return f == fieldKey ? key : value[f];
		}

		fieldNames.forEach((f, fidx) => {
			var fld = opts.fields[f];
			// console.log( 'field', fld )
			if (fld.type == 'text') {
				var ofield = $('<INPUT type="text">').addClass('option-text').prop('placeholder', fld.placeholder || fld.label);
				ofield.val(getField(f));
				if (!ofield.val()) ofield.prop('empty', true);

				if (fld.className) ofield.addClass(fld.className);
				ofield.on('change', function () { setField(f, ofield.val(), ofield); change(); })
				ofield.on('focus', function (ev) { $(this).select() })
				ofield.on('keydown', fieldKeyDown);
				ofield.change();
				if (fld.forceWidth) ofield.css({ width: fld.forceWidth })
				if (fld.css) ofield.css(fld.css);
				setNext(f, ofield, idx);
				opt.append(ofield);
				// console.log( 'ofield', obj[0].parentNode, 'opt', opt.html(), 'obj', obj.html(), 'hook', hook.html() )
				if (f == fieldKey && level) {
					var ml = level * 20;
					ofield.css({ marginLeft: ml, width: ofield.outerWidth() - ml });
				}
				if (idx == 0) optWidths.push(ofield.outerWidth());
				if (!emptyField && !fidx && !ofield.val()) emptyField = ofield;	
			}
			if (fld.type == 'textarea') {
				var ofield = $('<TEXTAREA>').addClass('option-text').prop('placeholder', fld.placeholder || fld.label);
				ofield.val(getField(f));
				if (!ofield.val()) ofield.prop('empty', true);

				if (fld.className) ofield.addClass(fld.className);
				ofield.on('change', function () { setField(f, ofield.val(), ofield); change(); })
				ofield.on('focus', function (ev) { $(this).select() })
				ofield.on('keydown', fieldKeyDown);
				ofield.change();
				if (fld.forceWidth) ofield.css({ width: fld.forceWidth })
				if (fld.forceHeight) ofield.css({ height: fld.forceHeight })
				if (fld.css) ofield.css(fld.css);
				setNext(f, ofield, idx);
				opt.append(ofield);
				// console.log( 'ofield', obj[0].parentNode, 'opt', opt.html(), 'obj', obj.html(), 'hook', hook.html() )
				if (f == fieldKey && level) {
					var ml = level * 20;
					ofield.css({ marginLeft: ml, width: ofield.outerWidth() - ml });
				}
				if (idx == 0) optWidths.push(ofield.outerWidth());
				if (!emptyField && !fidx && !ofield.val()) emptyField = ofield;
			}
			if (fld.type == 'option') {
				var options = fld.options;
				function optionFocus(ev) {
					// console.log( 'focus', outTid)
					clearTimeout(outTid);
					$(this).select()
					optionOut('option');
					var opt = $('<DIV>').addClass('option-list-options').html('');
					var pos = this.getBoundingClientRect();
					// console.log('pos', pos)
					opt.css({ top: pos.top + pos.height + $(window).scrollTop(), left: pos.left })
					$(document.body).append(opt);
					showOptions('');
				}

				function optionBlur() {
					outTid = setTimeout(optionOut, 500)
					// console.log( 'blur', outTid )
				}

				function optionSetVal( v ) {
					// console.log( 'optionSetVal', ofield[0],  v, fld.showOptionText )
					ofield.prop('fvalue', v );
					if( v && fld.showOptionText ) {
						let oo = fld.options.find( o => o.value == v );
						// console.log( 'optionSetVal oooooooo', oo )
						if( oo ) ofield.val( oo.text).prop('fvalue', oo.value );
						else ofield.prop('fvalue', '' ).val('')
					}
					else ofield.val( v );
					ofield.prop('empty', ofield.val() > '');
					// console.log( 'optionSetVal', ofield[0], ofield.val() )
				}

				function optionGetVal() {
					// console.log( 'optionGetVal', ofield.prop('fvalue'))
					return ofield.prop('fvalue');
				}

				function showOptions(s) {
					clearTimeout(outTid);
					// console.log( 'showOptoins', s )
					// console.log('showOptions', fld, 'field', f, 'idx', idx, 'olist', olist);
					var opt = $('.option-list-options');
					opt.html('');
					var reg = new RegExp(s, 'i');
					var out = [];
					var optionList = options;
					if (opts.optionListFilter) optionList = opts.optionListFilter(olist, idx, fld, fld.options)

					for (var o of optionList) {
						if (o.text.match(reg)) {
							out.push(o.value);
							opt.append($('<div class="option-list-option-item item-cname">' + o.text + '</div>').prop('value', o.value))
						}
					}
					$('.option-list-option-item').off('click').on('click', function () {
						// console.log('click')
						clearTimeout(outTid);
						optionSetVal( $(this).prop('value') );
						ofield.change();
						ofield.blur();
						optionOut('click');
					})
					return out;
				}

				function optionOut(from) {
					// console.log('OUT', from);
					$('.option-list-options').remove();
				}

				function optionKey(ev) {
					var c = showOptions($(this).val())
					console.log( 'KEY', c, $(this).val() )
					if (ev.keyCode == 13) {
						if (c.length == 1) optionSetVal(c[0]);
						else optionSetVal('');
						ofield.change();
						ofield.blur();
						optionOut('key');
					}
					else if( $(this).val().trim() == '' ) optionSetVal('')
					// console.log('evkey', ev.keyCode, $(this).val(), c);
				}



				function optionChange() {
					clearTimeout(outTid)
					outTid = setTimeout(function () {
						var val = optionGetVal();
						// console.log( 'CHECK', options, val, options, options.find( o => o.value == val ) )
						// if( val && options && !options.find( o => o.value == val ) )
						// {
						// 	ofield.val('');
						// 	optionOut('change');
						// 	return;
						// }
						// console.log('change', f, fidx, cname)
						if (opts.optionListCallback) opts.optionListCallback(olist, cname, f, val, idx);
						setField(f, val); change();
					}, 300)
				}
				var cname = colOptName(f).replace(/ /g, '-')
				var ofield = $('<INPUT type="text">').addClass(cname).addClass('option-text').prop('placeholder', fld.placeholder || fld.label);
				if (fld.className) ofield.addClass(fld.className);
				if (fld.className) ofield.addClass(fld.className);
				ofield.on('change', optionChange);
				ofield.on('focus', optionFocus);
				ofield.on('blur', optionBlur);
				ofield.on('keyup', optionKey);

				if (fld.forceWidth) ofield.css({ width: fld.forceWidth })
				if (fld.css) ofield.css(fld.css);
				setNext(f, ofield, idx);
				opt.append(ofield);
				// console.log( 'ofield', obj[0].parentNode, 'opt', opt.html(), 'obj', obj.html(), 'hook', hook.html() )
				if (f == fieldKey && level) {
					var ml = level * 20;
					ofield.css({ marginLeft: ml, width: ofield.outerWidth() - ml });
				}
				if (idx == 0) optWidths.push(ofield.outerWidth());
				// alert(fld.default || '')
				if( !getField(f) ) {
					setTimeout( function(){
						optionSetVal( fld.default || '' )
						ofield.change();
						ofield.blur();
						optionOut('click');
					}, 10 )
				}
				else {
						optionSetVal( getField(f) )
					// ofield.val();
				}
				ofield.change();
			}
			if (fld.type == 'list') {
				var ofield = $('<TEXTAREA>').addClass('option-text').prop('placeholder', fld.placeholder || fld.label);
				ofield.val((getField(f) || []).join('\n'));
				if (fld.className) ofield.addClass(fld.className);
				ofield.on('change', function () {
					var fval = ofield.val().trim();
					setField(f, fval ? fval.split('\n') : []); change();
				})
				ofield.on('focus', function (ev) { $(this).select() })
				ofield.on('keydown', fieldKeyDown);
				if (fld.forceWidth) ofield.css({ width: fld.forceWidth })
				if (fld.css) ofield.css(fld.css);
				ofield.change();
				setNext(f, ofield, idx);
				opt.append(ofield);
				if (f == fieldKey && level) {
					ml = level * 20;
					ofield.css({ marginLeft: ml, width: ofield.outerWidth() - ml });
				}
				if (idx == 0) optWidths.push(ofield.outerWidth());
			}
			if (fld.type == 'color') {
				var cont = $('<SPAN>').addClass('option-container');
				// if (!clr) clr = pcolors[((colorIdx++) * 7) % pcolors.length];
				// var ofield = $('<INPUT type="color">').text('color').val(clr);
				// Get the color value for the field

				//modified by Parthiban
				var clr = getField(f);
				// If no color value found, set it to a default color
				if (!clr) clr = pcolors[((colorIdx++) * 7) % pcolors.length];
				// Create the color input field and set its value
				var ofield = $('<INPUT type="color">').val(clr).attr('title', 'color');
				//modify ended

				ofield.on('change', function () { setField(f, ofield.val()); change(); })
				ofield.change();
				cont.append(ofield);
				if (fld.className) cont.addClass(fld.className);



				opt.append(cont);
				if (idx == 0) optWidths.push(cont.outerWidth());
			}
			if (fld.type == 'boolean') {
				var cont = $('<SPAN>').addClass('option-container');
				var ofield = $('<INPUT type="checkbox">').text('color').prop('checked', bool(getField(f))).prop('label', f);
				ofield.on('change', function () { setField($(this).prop('label'), $(this).prop('checked')); change(); })
				ofield.on('keydown', fieldKeyDown);
				ofield.change();
				setNext(f, ofield, idx);
				cont.append(ofield);
				if (fld.className) cont.addClass(fld.className);
				opt.append(cont);
				// console.log( 'bool', f, cont.outerWidth() )
				if (idx == 0) optWidths.push(fld.forceWidth || cont.outerWidth());
				if (fld.css) ofield.css(fld.css);
				var wid = optWidths[fidx];
				cont.css({ width: wid })
			}
		});


		function setNext(key, val, idx) {
			if (lastFields[key]) {
				lastFields[key].prop('next', val);
				val.prop('prev', lastFields[key]);
				val.prop('key', key);
				val.prop('idx', idx);
				val.addClass('cell' + colOptName(key) + '_' + idx)
			}
			lastFields[key] = val;
		}

		function fieldKeyDown(ev) {
			// console.log( 'keyCode', ev.keyCode, ev )
			if (ev.keyCode == 9 && ev.shiftKey) {
				this.blur();
				var nx = $(ev.target).prop('prev');
				if (nx) nx.focus();
				ev.preventDefault();
			}
			else if ((ev.target.tagName == 'INPUT' && ev.keyCode == 13) || ev.keyCode == 9) {
				this.blur();
				var nx = $(ev.target).prop('next');
				var nk = $(ev.target).prop('key');
				var ni = $(ev.target).prop('idx');
				// if( ev.keyCode == 13 && $(ev.target).prop('empty') )
				if (ev.keyCode == 13 && ni == olist.length - 1) {
					opt.find('.fa-plus')[0].click();
					var cl = '.cell' + colOptName(nk) + '_' + (ni + 1);
					// console.log('ENTER', cl)
					setTimeout(function () {
						hook.find(cl).focus();
					}, 200)
				}
				else if (nx) nx.focus();
				ev.preventDefault();
			}
		}

		// alert( objList )
		if (opts.hideButtons) return;
		if (opts.subLabels) {
			opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-angle-left"></i>').click(function () { cmd('left', idx) }));
			opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-angle-right"></i>').click(function () { cmd('right', idx) }));
		}
		opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-chevron-circle-up fa-lg"></i>').click(function () { cmd('up', idx) }));
		opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-chevron-circle-down fa-lg"></i>').click(function () { cmd('down', idx) }));
		opt.append($('<BUTTON>').addClass('red').html('<i class="fa fa-times-circle fa-lg"></i>').click(function () { cmd('del', idx) }));
		opt.append($('<BUTTON>').addClass('green').html('<i class="fa fa-plus-circle fa-lg"></i>').click(function () { cmd('add', idx) }));
	}

	function addOpts(sobj, level) {
		if (!level) level = 0;
		var idx = 0;
		if (!isobj(sobj)) return;
		for (var k in sobj) {
			var val = sobj[k];
			if (!defined(val)) val = null;
			if (isstring(val)) {
				var v = val;
				val = {};
				val[fieldDefault] = v;
			}
			olist.push({ key: k, value: val, level: level });
			if (isobj(val) && val.sublabels) addOpts(val.sublabels, level + 1)
		}
		// console.log( 'olist', olist );
	}

	function change() {
		var out = {};
		var stack = [out];
		olist.forEach((o, idx) => {
			// console.log( 'olist', o )
			if (!o.key || o.key.trim() == '') return;
			while (o.level >= stack.length) o.level--;
			stack[o.level][o.key] = o.value;
			o.value.sublabels = {};
			stack[o.level + 1] = o.value.sublabels;
		});
		function clean(o) {
			for (var k in o) {
				if (o[k].sublabels) {
					if (Object.keys(o[k].sublabels).length == 0) delete o[k].sublabels;
					else clean(o[k].sublabels);
				}
			}
		}
		clean(out);
		// console.log( 'OPTS', (opts) )
		if( opts.arrayOutput ) {
			let a = [];
			for( let k in out ) {
				let ao = {[opts.fieldKey]: k, ...out[k]}
				a.push( ao )
			}
			out = a;
			// alert( 1 )
		}
		if (callback) callback(out);
	}

	function draw() {
		// console.log( 'descriptor', descriptor )
		// console.log( 'draw')
		checkEmpty();
		lastName = null;
		lastAlias = null;
		obj.html('');
		olist[0].level = 0;
		optWidths = [];
		olist.forEach((o, idx) => {
			if (idx && o.level - olist[idx - 1].level > 1) o.level = olist[idx - 1].level + 1;
			addOpt(o.key, o.value, o.level, idx)
		});
		// console.log( 'optWidths', optWidths );
		// header

		var hopt = $('<DIV>').addClass('option-item').addClass('option-header-bar');
		obj.prepend(hopt);
		fieldNames.forEach((f, idx) => {
			var fld = opts.fields[f];
			// console.log( 'field', f, fld, optWidths[idx] )
			var h = $('<DIV>').text(fld.label).addClass('option-header').css({ width: optWidths[idx] });
			if (fld.className) h.addClass(fld.className);
			if (fld.css) h.css( fld.css )

			hopt.append(h);
		});
	}

	addOpts(source);

	function checkEmpty() {
		if (!olist.length) {
			olist.push({ key: '', value: {}, level: 0 })
		}
	}
	checkEmpty();

	draw();
	if (opts.callbackOnInit) change();
	var objList = { list: olist, draw: draw };
	// console.log( '--------------------------', objList )
	return objList;
	// console.log( 'olist', olist  )
}


function arr2Obj(a, keyName) {
	if (!a) a = [];
	var out = {};
	a.forEach(it => {
		// console.log('it', it, it[keyName])
		out[it[keyName]] = clone(it);
		delete out[keyName];
	})
	return out;
}

function obj2Arr(o, keyName) {
	if (!o) o = {};
	var out = [];
	for (var k in o) {
		var it = clone(o[k]);
		it[keyName] = k;
		out.push(it);
	}
	return out;
}

function arr2Bool(a) {
	if (!a) a = [];
	var out = {};
	a.forEach(it => { out[it] = true; });
	return out;
}

function bool2Arr(o) {
	if (!o) o = {};
	var out = [];
	for (var k in o) {
		if (o[k]) out.push(k);
	}
	return out;
}

// transform a objet with key and obj values to a { key: value, key2: value2, key3: value3 } object
function obj2Vals(o, keyName) {
	if (!o) o = {};
	var out = {};
	for (var k in o) {
		out[k] = o[k][keyName];
	}
	return out;
}

// transform a { key: value, key2: value2, key3: value3 } to a { key:{keyName:value}, key2:{keyName:value2}} object
function vals2Obj(o, keyName) {
	if (!o) o = {};
	var out = {};
	for (var k in o) {
		out[k] = {};
		out[k][keyName] = o[k];
	}
	return out;
}

function exists(o) {
	if (!o) return false;
	if (!isobj(o)) return false;
	return Object.keys(o).length > 0;
}

var _eventOutEvlist = [];
function eventOutside(obj, event, callback) {
	var domObj = $(obj)[0];
	function check(ev) {
		// console.log('check', ev.type, ev.target)
		if (ev.target == domObj || $(ev.target).closest(domObj).length) return true;
		return callback(ev);
	}
	$(document.body).on(event, check);
	var e = { ev: event, cb: check };
	_eventOutEvlist.push(e);
	return e;
}

function eventOutsideEnd(e) {
	// console.log( 'eventOutsideEnd' )
	if (e) return $(document.body).off(e.ev, e.cb);
	while (_eventOutEvlist.length) {
		var e = _eventOutEvlist.pop();
		$(document.body).off(e.ev, e.cb);
	}
	return null;
}

function set(ctx) {
	var list = {
		paletteWheel: paletteWheel,
		booleanList: booleanList,
		optionList: optionList,
		arr2Obj: arr2Obj,
		obj2Arr: obj2Arr,
		arr2Bool: arr2Bool,
		bool2Arr: bool2Arr,
		obj2Vals: obj2Vals,
		vals2Obj: vals2Obj,
		exists: exists,
	}
	for (var k in list) ctx[k] = list[k];
}

var loadedImages = {};
function formatPreview(a) {
	if (a.indexOf('adlthumb') == 0) {
		var thumbsize = 150;
		function loadImg(id) {
			if (id in loadedImages) return $('.' + id).prop('src', loadedImages[id]);
			loadedImages[id] = '';
			// console.log('loadImage', id, $('.' + id).length);
			window.post('load_file', { fileId: fileId, myId: window.GlobalVars.userId, resize: thumbsize }, function (res) {
				var file = res.data;
				var imgUrl = file.adlUrl;
				// console.log('LOAD_FILE', imgUrl);
				loadedImages[id] = imgUrl;
				return $('.' + id).prop('src', loadedImages[id])
			});
		}
		var [pref, fileId] = a.split(':');
		var img = '<div class="tabler-thumbnail" style="height: ' + thumbsize + 'px"><img src="" class="' + fileId + '"><span>image</span></div>';
		setTimeout(function () { loadImg(fileId) }, 100);
		return img;
	}
	return smallerText(a);
}

function formatThumb(th) {
	var [id, thumb, type] = th;
	if (thumb && thumb.match(/^file:/)) thumb = thumb.replace(/^file:/, '')
	// console.log('formatthumb', id, thumb, type)
	window.loadedImages = loadedImages;
	var mheight = 150;
	var mwidth = 200;
	var src = loadedImages[id] || '';
	var disp = 'display: none;';

	var fa = 'fa-file-text-o';
	if (type == 'audio/wav') fa = 'fa-file-sound-o';
	else if (type == 'audio/mpeg') fa = 'fa-file-sound-o';
	else if (type == 'image/png') fa = 'fa-file-image-o';
	else if (type == 'image/tiff') fa = 'fa-file-image-o';
	else if (type == 'image/jpeg') fa = 'fa-file-image-o';
	else if (type == 'video/mp4') fa = 'fa-file-video-o';
	else if (type == 'application/pdf') fa = 'fa-file-pdf-o';
	var typeIcon = '<i class="fa ' + fa + '"></i>';
	if (!thumb) {
		var img = '<span class="tabler-thumbnail thumb-' + id + '" title="' + type + ' document">' + typeIcon + '</span>';
		return img;
	}
	if (src) typeIcon = disp = '';
	var img = '<span class="tabler-thumbnail thumb-' + id + '" title="' + type + ' document">' + typeIcon + '<img src="' + src + '" taskid="' + id + '" class="img-thumb img-' + id + '" style="' + disp + 'max-height: ' + mheight + 'px; max-width: ' + mwidth + 'px"></span>';
	return img;
}

function formatThumbOld(th) {
	var [id, thumb, type] = th;
	// console.log('formatthumb', id, thumb, type)
	window.loadedImages = loadedImages;
	var mheight = 150;
	var mwidth = 200;
	var src = loadedImages[id] || '';
	var disp = 'display: none;';

	var fa = 'fa-file-text-o';
	if (type == 'audio/wav') fa = 'fa-file-sound-o';
	else if (type == 'audio/mpeg') fa = 'fa-file-sound-o';
	else if (type == 'image/png') fa = 'fa-file-image-o';
	else if (type == 'image/tiff') fa = 'fa-file-image-o';
	else if (type == 'image/jpeg') fa = 'fa-file-image-o';
	else if (type == 'video/mp4') fa = 'fa-file-video-o';
	else if (type == 'application/pdf') fa = 'fa-file-pdf-o';
	var typeIcon = '<i class="fa ' + fa + '"></i>';
	if (!thumb) {
		var img = '<span class="tabler-thumbnail thumb-' + id + '" title="' + type + ' document">' + typeIcon + '</span>';
		return img;
	}
	if (src) typeIcon = disp = '';
	var img = '<span class="tabler-thumbnail thumb-' + id + '" title="' + type + ' document">' + typeIcon + '<img src="' + src + '" taskid="' + id + '" class="img-thumb img-' + id + '" style="' + disp + 'max-height: ' + mheight + 'px; max-width: ' + mwidth + 'px"></span>';
	return img;
}

function loadThumbnails() {
	$('.img-thumb').each((idx, e) => {
		e = $(e);
		var id = e.attr('taskid');
		if (loadedImages[id]) return e.prop('src', loadedImages[id]);
		window.post('task_thumbnail', { taskId: id }, res => {
			var [th, type] = res.data;
			if (th) {
				if (th.match(/localhost/)) th = th.replace(/localhost/, document.location.hostname);
				loadedImages[id] = th;
				e.prop('src', loadedImages[id]);
				e[0].onload = function () {
					e.parent().find('i').remove();
					e.css({ display: '' })
				}
			}
		});
		// console.log('loadThumb', e, id)
	})
}

function progressBar(hook, css) {
	var progressContainer = $('<DIV>').addClass('progress-bar');
	if (css) progressContainer.css(css);
	var progressMeter = $('<DIV>').addClass('progress-bar-meter');
	progressContainer.append(progressMeter);
	hook.append(progressContainer)
	this.set = function (v) {
		progressMeter.css({ width: v * 100 + '%' });
	}
	return this;
}

function smallerText(txt) {
	if (!txt) txt = [];
	if (!isarray(txt)) txt = [txt];
	if (!txt.length) return ''
	return txt.map(t => '<div class="tabler-smaller">' + t + '</div>').join('')
}

function timeZone() {
	return new Date().toString().replace(/.*\(/, '(');
}

function localDateTime(v) {
	if (!v) return ''
	return new Date(v * 1000).toLocaleString();
}

function timeFromNow(ts) {
	if (!ts) return '-';
	var dt = Math.floor(Date.now() / 1000) - ts;
	if (dt < 60) return 'less than a minute';
	if (dt < 3600) return Math.floor(dt / 60) + ' minute' + (dt / 60 > 2 ? 's' : '');
	if (dt < 86400) return Math.floor(dt / 3600) + ' hour' + (dt / 3600 > 2 ? 's' : '');
	return Math.floor(dt / 86400) + ' day' + (dt / 86400 > 2 ? 's' : '');
}

function timeFuture(ts) {
	if (!ts) return '-';
	var dt = ts - Math.floor(Date.now() / 1000);
	if (dt < 0) return 'expired';
	if (dt < 60) return 'less than a minute';
	if (dt < 3600) return Math.floor(dt / 60) + ' minute' + (dt / 60 > 2 ? 's' : '');
	if (dt < 86400) return Math.floor(dt / 3600) + ' hour' + (dt / 3600 > 2 ? 's' : '');
	return Math.floor(dt / 86400) + ' day' + (dt / 86400 > 2 ? 's' : '');
}

function makeTaskList(list, fileId, project, callback) {
	var taskList = [];
	list.forEach(j => {
		if (j.data.project == project) taskList.push(j.data.fileId);
	})
	window.GlobalVars.taskList = {
		project: project,
		list: taskList,
		// idx: taskList.findIndex(t => t.fileId == fileId)
		idx: taskList.findIndex(t => t == fileId)
	};
	// console.log(window.GlobalVars.taskList)
	window.saveSession(callback);
}
var mainLeftOffset = 70;

function saveClipboard(txt) {
	var input = $('<textarea>').val(txt).css({ position: 'absolute', top: px(-10000), left: px(-100000) });
	$(document.body).append(input);
	input.select();
	// input.setSelectionRange(0, 99999999);
	document.execCommand("copy");
	setTimeout(function () {
		input.remove();
	}, 100);
}


function loading(str) {
	if (!str) str = '';
	$('.adl-lds-hourglass').remove();

	var ld = $('<div class="adl-lds-hourglass loading"><div class="lds-text">' + str + '</div></div>').css({
		position: 'fixed',
		// top:$('#maincolumn').outerHeight()/2-40,
		// top:$(window).height()/2-40,
		top: $(document.body).outerHeight() / 2 - 40,
		left: $(document.body).width() / 2 - 40,
	})
	$(document.body).append(ld);

}

function loadingOut() {
	$('.loading').remove();
}

window._loading = loading;

(function ($) {
	'use strict';

	var me = null;
	var HierarchySelect = function (element, options) {
		this.$element = $(element);
		this.options = $.extend({}, $.fn.hierarchySelect.defaults, options);
		this.$button = this.$element.children('button');
		this.$menu = this.$element.children('.dropdown-menu');
		this.$menuInner = this.$menu.children('.hs-menu-inner');
		this.$searchbox = this.$menu.find('input');
		this.$hiddenField = this.$element.children('input');
		this.previouslySelected = null;
		this.init();
		me = this;
		options.cfg.obj = this;
	};

	HierarchySelect.prototype = {
		constructor: HierarchySelect,
		init: function () {
			this.setWidth();
			this.setHeight();
			this.initSelect();
			this.clickListener();
			this.buttonListener();
			this.searchListener();
		},
		initSelect: function () {
			var hiddenFieldValue = this.$hiddenField.val();
			if (this.options.initialValueSet && hiddenFieldValue && hiddenFieldValue.length > 0) {
				this.setValue(hiddenFieldValue);
			} else {
				var item = this.$menuInner.find('a[data-default-selected]:first');
				if (item.length) {
					this.setValue(item.data('value'));
				} else {
					var firstItem = this.$menuInner.find('a:first');
					this.setValue(firstItem.data('value'));
				}
			}
		},
		setWidth: function () {
			this.$searchbox.attr('size', 100); // Fix min-width   modify 1 to 100 
			if (this.options.width === 'auto') {
				var width = this.$menu.width();
				this.$element.css('min-width', width + 2 + 'px');
			} else if (this.options.width) {
				this.$element.css('width', this.options.width);
				this.$menu.css('min-width', this.options.width);
				this.$button.css('width', '100%');
			} else {
				this.$element.css('min-width', '42px');
			}
		},
		setHeight: function () {
			if (this.options.height) {
				this.$menu.css('overflow', 'hidden');
				this.$menuInner.css({
					'max-height': this.options.height,
					'overflow-y': 'auto'
				});
			}
		},
		getText: function () {
			return this.$button.text();
		},
		getValue: function () {
			return this.$hiddenField.val();
		},
		setValue: function (value) {
			var a = this.$menuInner.children('a[data-value="' + value + '"]:first');
			this.setSelected(a);
		},
		enable: function () {
			this.$button.removeAttr('disabled');
		},
		disable: function () {
			this.$button.attr('disabled', 'disabled');
		},
		setSelected: function (a) {
			if (a.length && this.previouslySelected !== a) {
				var text = a.text();
				var value = a.data('value');
				this.previouslySelected = a;
				this.$button.html(text);
				this.$hiddenField.val(value);
				this.$menu.find('.active').removeClass('active');
				if (this.options.onChange) this.options.onChange(value, text);
				if (this.options.resetSearchOnSelection) this.resetSearch();
				a.addClass('active');
			}
		},
		moveUp: function () {
			var items = this.$menuInner.find('a:not(.d-none,.disabled)');
			var active = this.$menuInner.find('.active');
			var index = items.index(active);
			if (typeof items[index - 1] !== 'undefined') {
				this.$menuInner.find('.active').removeClass('active');
				items[index - 1].classList.add('active');
				processElementOffset(this.$menuInner[0], items[index - 1]);
				if (this.$searchbox.val().trim() != '')
					this.$searchbox.val($(items[index - 1]).text())
			}
		},
		moveDown: function () {
			var items = this.$menuInner.find('a:not(.d-none,.disabled)');
			var active = this.$menuInner.find('.active');
			var index = items.index(active);
			if (typeof items[index + 1] !== 'undefined') {
				this.$menuInner.find('.active').removeClass('active');
				if (items[index + 1]) {
					items[index + 1].classList.add('active');
					processElementOffset(this.$menuInner[0], items[index + 1]);
					if (this.$searchbox.val().trim() != '')
						this.$searchbox.val($(items[index + 1]).text())
				}
			}
		},
		resetSearch: function () {
			this.$searchbox.val('').trigger('propertychange');
		},
		selectItem: function () {
			var that = this;
			var selected = this.$menuInner.find('.active');
			if (selected.hasClass('d-none') || selected.hasClass('disabled')) {
				return;
			}
			setTimeout(function () {
				that.$button.focus();
			}, 5);
			selected && this.setSelected(selected);
			this.$button.dropdown('toggle');
		},
		clickListener: function () {
			var that = this;
			this.$element.on('show.bs.dropdown', function () {
				var selected = that.$menuInner.find('.active');
				selected && setTimeout(function () {
					var el = selected[0];
					let elMenu = selected.closest('.dropdown-menu');
					let elBut = elMenu.parent().find('button');
					// console.log('selected', elBut[0], elMenu.width(), elBut.width(), elBut.outerWidth())
					elMenu.css({ minWidth: elBut.outerWidth() })

					if (el) {
						var p = selected[0].parentNode;
						if (!(p.scrollTop <= el.offsetTop - p.offsetTop && (p.scrollTop + p.clientHeight) > el.offsetTop + el.clientHeight)) {
							el.parentNode.scrollTop = el.offsetTop - el.parentNode.offsetTop;
						}
					}
				}, 0);
			});
			this.$element.on('hide.bs.dropdown', function () {
				that.previouslySelected && that.setSelected(that.previouslySelected);
			});
			this.$element.on('shown.bs.dropdown', function () {
				that.previouslySelected = that.$menuInner.find('.active');
				that.$searchbox.focus();
			});
			this.$menuInner.on('click', 'a', function (e) {
				e.preventDefault();
				var $this = $(this);
				if ($this.hasClass('disabled')) {
					e.stopPropagation();
				} else {
					that.setSelected($this);
				}
			});
		},
		buttonListener: function () {
			var that = this;
			if (this.options.search) {
				return;
			}
			this.$button.on('keydown', function (e) {
				switch (e.keyCode) {
					case 9: // Tab
						if (that.$element.hasClass('show')) {
							e.preventDefault();
						}
						break;
					case 13: // Enter
						if (that.$element.hasClass('show')) {
							e.preventDefault();
							that.selectItem();
						}
						break;
					case 27: // Esc
						if (that.$element.hasClass('show')) {
							e.preventDefault();
							e.stopPropagation();
							that.$button.focus();
							that.previouslySelected && that.setSelected(that.previouslySelected);
							that.$button.dropdown('toggle');
						}
						break;
					case 38: // Up
						if (that.$element.hasClass('show')) {
							e.preventDefault();
							e.stopPropagation();
							that.moveUp();
						}
						break;
					case 40: // Down
						if (that.$element.hasClass('show')) {
							e.preventDefault();
							e.stopPropagation();
							that.moveDown();
						}
						break;
					default:
						break;
				}
			});
		},
		searchListener: function () {
			var that = this;
			if (!this.options.search) {
				this.$searchbox.parent().toggleClass('d-none', true);
				return;
			}
			function disableParents(element) {
				var item = element;
				var level = item.data('level');
				while (typeof item === 'object' && item.length > 0 && level > 1) {
					level--;
					item = item.prevAll('a[data-level="' + level + '"]:first');
					if (item.hasClass('d-none')) {
						item.toggleClass('disabled', true);
						item.removeClass('d-none');
					}
				}
			}
			this.$searchbox.on('keydown', function (e) {
				switch (e.keyCode) {
					case 9: // Tab
						e.preventDefault();
						e.stopPropagation();
						that.$menuInner.click();
						that.$button.focus();
						break;
					case 13: // Enter
						var s = $(this).val().trim();
						if (s > '' && that.options.cfg.allowNew) {
							var s = $(this).val().trim();
							if (that.options.cfg.list.indexOf(s) == -1) {
								that.options.cfg.list.unshift(s);
							}
							that.options.cfg.root.setOptions(that.options.cfg.list, s);
							that.options.cfg.callback(s)
							setTimeout(function () {
								// console.log('click')
								that.$button.click()
							}, 100)
							return;
						}
						var list = that.$menu.find('a:not(.d-none)');
						if (list.length == 1) return list[0].click();
						that.selectItem();
						break;
					case 27: // Esc
						e.preventDefault();
						e.stopPropagation();
						that.$button.focus();
						that.previouslySelected && that.setSelected(that.previouslySelected);
						that.$button.dropdown('toggle');
						break;
					case 38: // Up
						e.preventDefault();
						that.moveUp();
						break;
					case 40: // Down
						e.preventDefault();
						that.moveDown();
						break;
					default:
						break;
				}
			});
			this.$searchbox.on('input propertychange', function (e) {
				e.preventDefault();
				//AQUI
				var searchString = that.$searchbox.val().toLowerCase();
				that.options.cfg.root.dynamicSearch(searchString);
				var items = that.$menuInner.find('a');
				if (searchString.length === 0) {
					items.each(function () {
						var item = $(this);
						item.toggleClass('disabled', false);
						item.toggleClass('d-none', false);
					});
				} else {
					items.each(function () {
						var item = $(this);
						var text = item.text().toLowerCase();
						if (text.indexOf(searchString) !== -1) {
							item.toggleClass('disabled', false);
							item.toggleClass('d-none', false);
							if (that.options.hierarchy) {
								disableParents(item);
							}
						} else {
							item.toggleClass('disabled', false);
							item.toggleClass('d-none', true);
						}
					});
				}
			});
		}
	};

	var Plugin = function (option) {
		var args = Array.prototype.slice.call(arguments, 1);
		var method;
		var chain = this.each(function () {
			var $this = $(this);
			var data = $this.data('HierarchySelect');
			var options = typeof option === 'object' && option;
			if (!data) {
				$this.data('HierarchySelect', (data = new HierarchySelect(this, options)));
			}
			if (typeof option === 'string') {
				method = data[option].apply(data, args);
			}
		});
		if (chain.length) chain.prop('method', me)
		return (method === undefined) ? chain : method;
	};

	var old = $.fn.hierarchySelect;

	$.fn.hierarchySelect = Plugin;
	$.fn.hierarchySelect.defaults = {
		width: 'auto',
		height: '256px',
		hierarchy: true,
		search: true,
		initialValueSet: false,
		resetSearchOnSelection: false
	};
	$.fn.hierarchySelect.Constructor = HierarchySelect;

	$.fn.hierarchySelect.noConflict = function () {
		$.fn.hierarchySelect = old;
		return this;
	};

	function processElementOffset(parent, element) {
		if (parent.offsetHeight + parent.scrollTop < element.offsetTop + element.offsetHeight) {
			parent.scrollTop = element.offsetTop + element.offsetHeight - parent.offsetHeight;
		} else if (parent.scrollTop >= element.offsetTop - parent.offsetTop) {
			parent.scrollTop = element.offsetTop - parent.offsetTop;
		}
	}
})($);

function itemList(hook, values, listed, options, callback) {
	var vlist = values;
	if (!listed) listed = [];
	if (isstring(listed)) listed = listed.split(',')
	listed = listed.filter(l => l != '')
	var list = $('<div>').addClass('item-list');
	hook.append(list);
	var firstVal = true;
	values.unshift('')
	var d = dropDown(list, values, null, options, function (v) {

		console.log( 'DROPDOWN', v )

		if (firstVal) return firstVal = false;
		if (listed.indexOf(v) == -1) listed.push(v);
		showList();
		// updateList();
		callback(listed);
	}).css({ display: 'block' });
	var button = d.find('button');
	var w = (options.width || (button.outerWidth() + 2));
	var h = (button.outerHeight() || 36) + 2;
	// console.log('ITEMLIST', w, h)
	list.css({ width: w, height: h, margin: 0, padding: 0 })
	button.css({ width: 0, border: 0, padding: 0, overflow: 'hidden', height: h })[0].className = '';
	var content = $('<div class="item-list-content"></div>')
	content.css({ width: w, minHeight: h })
	list.append(content);
	var valLabels = {};
	for (var v of values) {
		if (isobj(v)) {
			valLabels[v.value] = v.label;
		}
		else valLabels[v] = v;
	}
	function showList() {
		if (listed.length == 0) {
			if (options.placeholder) content.html('<span class="placeholder">' + options.placeholder + '</span>');
			return;
		}
		content.html('');
		for (var l of listed) {
			// console.log( 'cloud', l, valLabels[l] )
			var lab = $('<span>').addClass('item-list-label').html('<nobr>' + valLabels[l] + '&nbsp;<i class="fa fa-times-circle"></i></nobr>')
			lab.find('I').prop('val', l).on('click', function (ev) {
				console.log('delete', $(this).prop('val'))
				var ldel = $(this).prop('val');
				listed = listed.filter(l => l != ldel);
				showList();
				// updateList();
				callback(listed);
				ev.preventDefault();
				ev.stopPropagation();
			})
			content.append(lab);
		}
		var ch = content.height() + 20;

		list.css({ height: Math.max(h, ch) })
	}
	function updateList() {
		vlist = values.filter(v => {
			if (v.value) return listed.indexOf(v.value) == -1;
			return listed.indexOf(v) == -1;
		})
		d.setOptions(vlist);
	}
	showList();
	list.on('click', function (ev) {
		if (ev.target.tagName == 'A') return;
		// ev.preventDefault();
		// ev.stopPropagation();
		if (vlist.length > 1) d.showOptions()
	})

	// list.html('hello')
	window.ooo = options;
	window.ddd = d;
}

function dropDown(hook, values, select, options, callback) {
	var drop = $(`
<div class="dropdown hierarchy-select">
    <button type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
    <div class="dropdown-menu" aria-labelledby="example-two-button">
        <div class="hs-searchbox">
            <input type="text" class="form-control"  autocomplete="off">
        </div>
        <div class="hs-menu-inner">
        </div>
    </div>
    <input class="d-none" name="example_two" readonly="readonly" aria-hidden="true" type="text"/>
</div>
    `);
	if (!options) options = {};
	// if( options.allowNew ) drop.find('.dropdown-toggle').removeClass('dropdown-toggle') mani
	if (options.allowNew) drop.find('.dropdown-toggle')
	var cb = callback;
	function sendCallback(v) {
		if (v != select) {
			select = v;
			cb(v)
		}
	}
	callback = sendCallback;
	options.callback = callback;
	function placeholder() {
		if (!options.placeholder) return;
		setTimeout(function () {
			drop.find('button').html('<span class="placeholder">' + options.placeholder + '</span>')
		}, 1)
	}

	var sOptions = [];
	function setOptions(values, oselect) {
		// check if oselect belongs to options. If not, oselect = first option
		let ckSelect = null;
		for (var o of values) {
			let k = (isobj(o)) ? o.value : o;
			if( oselect == k ) ckSelect = k;
		}
		console.log( 'ckSelect', ckSelect );
		if( !ckSelect ) oselect = isobj(values[0]) ? values[0].value : values[0];


		// console.log( 'setOptions', JSON.stringify(values, null, '\t'), oselect )
		var alist = []
		var slabel = '';
		var selFound = false;
		sOptions = clone(values);
		options.list = values;
		select = null;
		function addVal(val, label) {
			// console.log( 'addVal', val, label, oselect, val == oselect )
			if (val == oselect) selFound = true;
			if (label === '') {
				var a = '<a class="dropdown-item" style="display:none" data-value="' + val + '" href="#"></a>';
			}
			else if (val == oselect) {
				var a = '<a class="dropdown-item" data-value="' + val + '" data-default-selected="" href="#">' + label + '</a>'
				slabel = label;
			}
			else var a = '<a class="dropdown-item" data-value="' + val + '" href="#">' + label + '</a>';
			alist.push(a);
		}
		for (var o of values) {
			if (isstring(o) || isnumber(o)) addVal(o, o);
			else addVal(o.value, o.label);
		}
		if (!selFound) oselect = null;
		drop.find('.hs-menu-inner').html(alist.join(''));
		var method = drop.prop('method');
		if (method) method.setValue(oselect)
		if (!oselect) placeholder();
		// console.log( 'setOptions', selFound )
	}
	setOptions(values, select)
	drop.addClass('imgcls-dropdown')
	drop.find('input').on('keyup', function (ev) {
		if (ev.keyCode == 13) {
			// if( options.allowNew ) {
			// 	var s = drop.find('input').val().trim();
			// 	if( sOptions.indexOf(s) == -1 ) {
			// 		sOptions.unshift(s);
			// 	}
			// 	setOptions( sOptions, s );
			// 	ret[0].method.$button.click()
			// 	callback(s)
			// 	return;
			// }
			// var list = drop.find('a:not(.d-none)');
			// if (list.length == 1) list[0].click();
		}
	})

	var width = options.width || 'auto'

	hook.append(drop);
	var ret = drop.hierarchySelect({
		hierarchy: false,
		width: width,
		resetSearchOnSelection: true,
		cfg: options,
		search: 'search' in options ? options.search : 'true',
		onChange: function (v) {

			if (v === '') placeholder();
			// console.log( 'callback', v )
			callback(v);
		},
	});

	function dynamicSearch(s) {
		if (options.dynamicSearch) options.dynamicSearch(ret, s)
		return false;
	}

	ret.setOptions = setOptions
	ret.dynamicSearch = dynamicSearch;
	ret.setValue = function (v) {
		drop.prop('method').setValue(v);
	}

	ret.showOptions = function () {
		setTimeout(function () {
			ret[0].method.$button[0].click();
		}, 1)
	}
	options.root = ret;
	return ret;
}

var getPresignedTid = null;
var getPresignedList = [];
var getPresignedImageBuff = {};
var getPresignedId = 0;
function getPresignedImage(img, conf, url) {
	if (url.match(/^http/)) {
		img.prop('src', url);
		return;
	}
	var sconf = JSON.stringify(conf);
	if (getPresignedImageBuff[sconf + url]) {
		// console.log( 'cached', sconf+url, '->', getPresignedImageBuff[sconf+url])
		return setTimeout(function () {
			img.prop('src', getPresignedImageBuff[sconf + url])
		}, 1);
	}
	clearTimeout(getPresignedTid);
	// console.log( 'getPresignedImage', img, sconf, url )
	getPresignedList.push({ idx: getPresignedId++, state: 0, img: img, conf: sconf, url: url });
	getPresignedTid = setTimeout(fetchPresignedImages, 100)
	return '';
}

function fetchPresignedImages() {
	var tmp = {};
	var imgs = [];
	var keys = {};
	var i = 0;
	var now = Date.now();
	if (getPresignedList.length == 0) {
		getPresignedTid = setTimeout(fetchPresignedImages, 10)
		return;
	}
	for (var p of getPresignedList) {
		if (p.state) continue;
		p.state = 1;
		p.img.prop('id', "img_" + (now + p.idx))
		// console.log( 'iiiiiiiiiiiiii', "img_"+(now+i))
		// imgs.push( p.img );
		var key = p.conf + p.url;
		// keys.push( key );
		keys[p.idx] = key;
		if (!tmp[p.conf]) tmp[p.conf] = [];
		tmp[p.conf].push({ idx: p.idx, url: p.url });
		i++;
	}
	var payload = [];
	for (var k in tmp) {
		payload.push({ conf: JSON.parse(k), urls: tmp[k] })
	}
	// console.log( 'fetchPresigned ddddddddddddddd',payload )
	window.post('fetchPresigned', { payload: payload }, res => {
		console.log('fetchPresigned-->',res);		
		// getPresignedList = [];
		var data = res.data;
		for (var i = 0; i < data.length; i++) {
			var idx = data[i].idx;
			var url = data[i].url;
			getPresignedImageBuff[keys[idx]] = url;
			// console.log( 'keys', idx, keys[idx])
			// console.log( 'url', imgs[idx][0], url )
			var o = getPresignedList.find(g => g.idx == idx);
			o.state = 2;
			o.img.prop('src', url)
		}
		// console.log( 'getPresignedImageBuff', getPresignedImageBuff )
		getPresignedList = getPresignedList.filter(g => g.state < 2)
		// console.log( 'GETPRESIGNEDLIST', getPresignedList )
		// console.log( 'fetch doneeee', data )
		// console.log( 'getPresignedImageBuff', getPresignedImageBuff )
	})
}

var dotEsc = '&#46;';
var dotEscReg = new RegExp(dotEsc, 'g');
function undotKeys(o) {
	var changed = false;
	if (isobj(o)) {
		var klist = Object.keys(o);
		for (var k of klist) {
			if (k.match(/\./)) {
				var ok = k;
				let v = o[k];
				delete o[k];
				k = k.replace(/\./g, dotEsc);
				// console.log( 'UNDOT', ok, k )
				o[k] = v;
				changed = true;
			}
			changed = undotKeys(o[k]) || changed
		}
	} else if (isarray(o)) {
		for (var i of o) changed = undotKeys(i) || changed;
	}
	return changed;
}

function dotKeys(o) {
	var changed = false;
	if (isobj(o)) {
		var klist = Object.keys(o);
		for (var k of klist) {
			if (k.match(dotEscReg)) {
				var ok = k;
				let v = o[k];
				delete o[k];
				k = k.replace(dotEscReg, '.');
				// console.log( 'DOT', ok, k )
				o[k] = v;
				changed = true;
			}
			changed = dotKeys(o[k]) || changed
		}
	} else if (isarray(o)) {
		for (var i of o) changed = dotKeys(i) || changed;
	}
	return changed;
}

var converSelectTid = null;

function selectUpdate(o) {
	// if (!$(o).is(':visible')) return;
	// console.log( 'selectUpdate xxx', o[0].id, o.is(':visible'), 'dup', o[0].disableUpdate, 'disabled', $(o).attr('disabled') )
	if (o[0].disableUpdate) return
	o[0].disableUpdate = true;
	// console.log('selectUpdate1', o[0].id, $(o).prop('dropdown'))
	$(o).show();
	var d = $(o).prop('dropdown');
	if (d) {
		var wid = $(o).outerWidth();
		d.find('button').css({ width: wid });
		d.css({ width: wid })
		$(o).hide();

		var opts = [];
		var options = Array.from($(o).find('option'));
		for (var opt of options) opts.push({ label: opt.innerHTML, value: opt.value })
		var val = $(o).val();
		if ($(o).attr('disabled')) {
			d.find('button').attr('disabled', true)
			d.addClass('form-disabled');
			d.closest('.hierarchy-select').css({ width: 'auto', minWidth: 'auto' });
			opts = opts.filter(opt => opt.value == val)
		}
		d.setOptions(opts, $(o).val());
	}
	setTimeout(function () {
		o[0].disableUpdate = false;
	}, 100)
	// console.log('selectUpdate done')
}

if (!window.observer) {
	window.observer = new MutationObserver(function (list) {
		for (var l of list) {
			// console.log( 'observe fired', l.target, l.target.tagName )
			if (l.target.tagName == 'SELECT') {
				selectUpdate($(l.target, true))
			}
			else convertSelects();
		}
	});
}

function patchVal(o) {
	// return;
	// console.log('patchVal', o, o.constructor._val)
	if (o.constructor.fn._val) return;
	window.dolar = o.constructor;
	o.constructor.fn._val = o.constructor.fn.val;
	o.constructor.fn.val = function () {
		if (this[0] && this[0].tagName && this[0].tagName == 'SELECT' && this.prop('dropdown') && typeof (arguments[0]) != 'undefined') {
			if (this.val() != arguments[0]) {
				this.prop('dropdown').setValue(arguments[0])
			}
		}
		return o.constructor.fn._val.apply(this, arguments);
	}
	// o.constructor.fn.val = function() {
	// 	console.log( 'VAAAAAAAAAAl', arguments, this );
	// 	if( this[0].tagName == 'SELECT' && this.prop('dropdown') ) {
	// 		selectUpdate(this)
	// 	}
	// 	return o.constructor._val.apppl(this,arguments);
	// }
}

function convertSelects(jobj) {
	// return;
	if (jobj) patchVal(jobj)
	// frm.dropDown($('.dataset-tags'), ctags, '', { allowNew: true, placeholder: 'select tag', width: '100%' }, function (v) {
	var selects = Array.from($('select'));
	for (var s of selects) {
		// if( s.id != 'annotatorMaxTask') continue;
		s = $(s);
		if (!s.prop("observed")) {
			s.prop("observed", 1)
			// console.log('will observe', s[0])
			window.observer.observe(s[0], { subtree: true, childList: true, attributes: true })
		}
		let vis = s.is(':visible');
		if (!vis) {
			var inv = s[0].parentElement;
			for (var o = inv; o && !$(o).is(':visible'); o = o.parentElement)
				inv = o;
			if (inv && !$(inv).prop("observed")) {
				$(inv).prop("observed", 1);
				window.observer.observe(inv, { subtree: true, childList: true, attributes: true });
				// console.log('observed_parent', s[0], 'inv', inv)
			}
			continue;
		}
		let dropdown = s.prop('dropdown') || null;
		if (dropdown) continue;
		// console.log(s[0], vis)

		let placeholder = s.attr('placeholder')
		let dropHook = $('<span></span>');
		let dropOpt = { placeholder: placeholder }
		let scss = s.prop('css');
		if (scss) for (var k in scss) dropOpt[k] = scss[k];
		// if( s.width() > 0 ) dropOpt.width = s.outerWidth();
		dropHook.addClass(s[0].className).css({ border: 0, padding: 0 })
		s.before(dropHook)
		let options = Array.from(s.find('option')).map((o, idx) => { return { value: o.value, label: o.innerHTML, idx: idx } });
		let selected = s.val();
		let obj = s;
		let first = true;
		// s[0].onchange = function(v) {
		// 	alert('change '+v)
		// }
		let cb = function (v) {
			if (first) return first = false;
			obj.val(v).change();
			// var opt = options.find( o => o.value == v );
			// if( opt ) {
			// 	// console.log( 'opt', opt, options, v, opt.idx )
			// 	console.log( obj[0], opt.idx, obj.find('option')[opt.idx] )
			// 	obj.find('option')[opt.idx].click();
			// }
		}
		var d = dropDown(dropHook, options, selected, dropOpt, cb).addClass('imgcls-dropdown-setup')
		// console.log('selectUpdate aaa', d, s[0])
		var wid = s.outerWidth();
		d.find('button').addClass('dropdown_' + s.prop('id')).css({ width: wid });
		d.css({ width: wid })
		// .addClass( s[0].className )
		s.prop('dropdown', d)
		// s.prop('css', css)
		s.hide();
	}
}


function paginator(hook, num, tot, callback) {
	if (tot == 1) return;
	if (!callback) callback = function (n) { console.log('paginator', n) }
	var cont = $('<div>').addClass('npaginator');
	var wrapper = $('<div>').addClass('nwrapper');
	var prev = $('<span>').addClass('nprev').html('<i class="fa fa-chevron-left"></i>');
	var page = $('<input>').addClass('npage').val(num || 1);
	var stot = $('<span>').addClass('ntot').html('of <span class="totpag">' + tot + '</span>');
	var next = $('<span>').addClass('nnext').html('<i class="fa fa-chevron-right"></i>');
	page.on('change', function (ev) {
		var p = page.val() * 1 || 1;
		if (p > tot) p = tot;
		if (p < 1) p = 1;
		page.val(p);
		page[0].blur();
		callback(p)
	})
	page.on('focus', function () {
		page[0].select();
	})
	prev.on('click', function (ev) {
		var p = page.val() * 1 || 1;
		if (p > 1) {
			p--;
			page.val(p)
			callback(p)
		}
		ev.preventDefault();
		ev.stopPropagation();
	})
	next.on('click', function (ev) {
		var p = page.val() * 1 || 1;
		if (p < tot) {
			p++;
			page.val(p)
			callback(p)
		}
		ev.preventDefault();
		ev.stopPropagation();
	})
	wrapper.append(prev, page, stot, next);
	var totnum = stot.find('.totpag');
	cont.append(wrapper);
	hook.append(cont);
	page.css({ width: totnum.width() + 20 })
}


let configId = Date.now();
function configSection( hook, title, open ) {
	let titclass = 'section_' + simplify(title);
	let prev = $('.'+titclass)
	if( prev.length ) {
		return prev.html('');
	}

	$(hook).addClass('project-panel')
	let id = configId++;
	let csid = 'collapse'+id;
	let hdid = 'header'+id;
	let bstate = open ? 'true' : 'false';
	let iicon = open ? 'down' : 'up';
	let html = '<div class="project-section project-aws"><button class=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#'+csid+'" aria-expanded="'+bstate+'" aria-controls="'+csid+'"><h1>'+title+'</h1><i class="fa fa-chevron-'+iicon+' acc"></i></button><div id="'+csid+'" class="collapse show config '+titclass+'" aria-labelledby="'+hdid+'" ></div></div>';
	
	$(hook).append($(html));
	let ret = $('#'+csid);
	if( !open ) ret.removeClass('show')
	return ret;
}


//////////////////////////////////////////////////////////////////////////////
/// sample config payload
//////////////////////////////////////////////////////////////////////////////
// let llms = [
// 	{
// 		"key": "enableEmbedingsModel",
// 		"title": "Some title",
// 		"label": "Enable Embeddings Model",
// 		"type": "boolean",
// 		"default": false,
// 		"subFields": [
// 			{
// 				"title": "Embeddings Model",
// 				"key": "embeddingModel",
// 				"type": "dropdown",
// 				"placeholder": "Select embeddings model",
// 				"options": [
// 					{
// 						"value": "gpt2",
// 						"label": "GPT-2",
// 						"filter": [
// 							"PDF",
// 							"Text",
// 							"PDFOCR"
// 						]
// 					},
// 					{
// 						"value": "gpt3",
// 						"label": "OpenAI GPT-3",
// 						"filter": [
// 							"PDF",
// 							"Text",
// 							"PDFOCR"
// 						],
// 						"subFields": [
// 							{
// 								"title": "Endpoint",
// 								"key": "endpoint",
// 								"placeholder": "OpenAI Endpoint",
// 								"type": "url"
// 							},
// 							{
// 								"title": "Key",
// 								"key": "key",
// 								"placeholder": "OpenAI Key",
// 								"type": "string"
// 							}
// 						]
// 					},
// 					{
// 						"value": "gpt4",
// 						"label": "OpenAI GPT-4",
// 						"filter": [
// 							"PDF",
// 							"Text",
// 							"PDFOCR"
// 						],
// 						"subFields": [
// 							{
// 								"title": "Endpoint",
// 								"key": "endpoint",
// 								"placeholder": "OpenAI Endpoint",
// 								"type": "url"
// 							},
// 							{
// 								"title": "Key",
// 								"key": "key",
// 								"placeholder": "OpenAI Key",
// 								"type": "string"
// 							}
// 						]
// 					},
// 					{
// 						"value": "Image Similarity",
// 						"label": "Image Similarity",
// 						"filter": [
// 							"Image",
// 							"Video",
// 							"Audio"
// 						],
// 						"subFields": [
// 							{
// 								"key": "accuracy",
// 								"label": "Acuracy Threshold",
// 								"type": "float"
// 							}
// 						]
// 					},
// 					{
// 						"value": "Audio Similarity",
// 						"label": "Audio Similarity",
// 						"filter": [
// 							"Audio"
// 						],
// 						"subFields": [
// 							{
// 								"key": "format",
// 								"label": "Acuracy Threshold",
// 								"type": "dropdown",
// 								"options": [
// 									"mp3",
// 									"wav",
// 									"flac",
// 									"ogg"
// 								],
// 								"allowNew": true
// 							}
// 						]
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		"key": "something",
// 		"title": "Some other field",
// 		"placeholder": "type something here",
// 		"type": "string"
// 	},
// 	{
// 		"key": "something2",
// 		"title": "Some other field2",
// 		"placeholder": "type something here2",
// 		"type": "string",
// 		"width": 100
// 	},
// 	{
// 		"key": "someNumber",
// 		"title": "some other field",
// 		"placeholder": "some number",
// 		"type": "float"
// 	},
// 	{
// 		"key": "format",
// 		"title": "File format",
// 		"type": "dropdown",
// 		"placeholder": "select a format",
// 		"options": [
// 			"mp3",
// 			"wav",
// 			"flac",
// 			"ogg"
// 		],
// 		"width": '100%',
// 		"allowNew": true
// 	}
// ];

function oKey(a, b, set) {
	// console.log( 'oKey', a, b, set )
	let ob = b;
	let isset = typeof (set) != 'undefined';
	try {
		b = (b || '').split('.');
		while (b.length > 1) {
			let k = b.shift();
			if( isset && typeof( a[k] ) != 'object') a[k] = {};
			a = a[k];
		}
		if (isset) {
			// console.log( 'oKey SET', a, ob, set )
			a[b[0]] = set;
		}
		return a[b[0]];
	}
	catch (e) { return null }
}

function requiredInputs() {
	removeInlineErrors();
	let list = $('.field_required');
	let missing = false;
	for( let l of list ) {
		console.log( 'TEST REQUIRED', l, $(l).prop('required') );
		if( ($(l).val && ($(l).val()||'').trim() == '') && ($(l).attr('val')||'').trim() == '' ) {
			inlineError( $(l), $(l).prop('required_message'))
			missing = true;
		}
	}
	return missing;
}

function configOptions(hook, list, varObj, filter) {
	if( !filter ) filter = function(){ return true }
	setTimeout(function () {
		for (let o of list) {
			// let id = configId++;
			if( !filter(o) ) continue;
			let id = o.key;
			let cid = 'op' + id;
			let fldid = 'fld' + id;

			let cont = $('<div>');
			if( o.containerClass ) cont.addClass( o.containerClass );
			if( o.conteinerCss ) cont.css( o.containerCss )
			$(hook).append(cont)
			if (o.type == 'boolean') {
				if (o.title) {
					let lab = $('<label for="' + cid + '">' + o.title + '</label>')
					cont.append(lab);
				}
				let opt = $('<div>').prop('id', cid);
				let fld = $('<div>').prop('id', fldid).css({paddingLeft:30});
				cont.append(opt, fld);
				let oval = oKey(varObj,o.key);
				console.log( 'BOOL', o.key, oval )
				if( oval === null || oval === undefined  ) oval = o.default || false;
				oKey(varObj,o.key, oval);
				booleanList(opt, varObj, {
					items: {
						// [o.key]: { default: oKey(varObj,o.key), label: o.label },
						[o.key]: { default: oval, label: o.label },
					},
					callbackOnInit: true,
				}, function (v) {
					// console.log('OOOOOOOOOOOOOOOOOOOOO', o.key, v[o.key])
					oKey(varObj,o.key,v[o.key]);
					fld.html('');
					function cb(){
						if( o.callback ) {
							setTimeout( function(){
								o.callback( Object.values(v)[0] );
							}, 1 )
						}
					}
					if (v[o.key] && o.subFields) {
						setTimeout(function () {
							configOptions(fld, o.subFields, varObj, filter)
							cb();
						}, 0)
					}
					else cb();
				});
			}
			else if (o.type == 'gridlist' ) {
				if (o.title) {
					let lab = $('<label for="' + cid + '">' + o.title + '</label>')
					cont.append(lab);
				}
				let opt = $('<div>').prop('id', cid);
				let fld = $('<div>').prop('id', fldid).css({paddingLeft:30});
				cont.append(opt, fld);
				let iniObj = oKey(varObj,o.key );
				// console.log( 'INIOBJ', JSON.stringify(varObj.ssoGroups))
				let fields = o.fields || { 'text': {type: 'text', placeholder: 'Enter text', label: 'Text'}}
				let defaultField = o.defaultField || Object.keys(fields)[0];
				let fieldKey = o.fieldKey || Object.keys(fields)[0];
				let callbackOnInit = 'callbackOnInit' in o ? o.callbackOnInit : true;
				let cfg = {
					fields: fields,
					defaultField: defaultField,
					fieldKey: fieldKey,
					callbackOnInit: callbackOnInit,
					arrayOutput: o.arrayOutput || false,
				}
				// console.log( 'CFG', cfg )
				optionList(opt, iniObj, cfg, function (v) {
					// console.log( 'ddddddd', v, varObj, o.key )
					oKey(varObj,o.key,v);
					if( o.callback ) o.callback( oKey( varObj, o.key) )
				});		
			}
			else if (o.type == 'dropdown') {
				if (o.title) {
					let lab = $('<label for="' + cid + '">' + o.title + '</label>')
					cont.append(lab);
				}
				let opt = $('<div>').prop('id', cid);
				let fld = $('<div>').prop('id', fldid);
				cont.append(opt, fld);
				let olist = o.options.filter( v => v instanceof Object ? filter(v) : true );
				let oval = oKey(varObj,o.key);
				if (!o.forceValue) olist.unshift({ value: '', label: '&nbsp;' })
				else if( !oval ) oval = olist[0].value;
				// console.log( 'OPTIONS', olist )
				oKey(varObj,o.key,oval);
				let drp = null;
				drp = dropDown(opt, olist, oKey(varObj,o.key), { placeholder: o.placeholder, width: o.width, allowNew: o.allowNew }, function (v) {
					// console.log( 'VVVVVVVVVVVVV', v )
					oKey(varObj,o.key,v);
					setTimeout( function(){ // need tobe settimeout as this callback is called before the final assigment to drp ends
						drp.attr('val',v)
					}, 0 )
					if( o.callback ) o.callback( v, o );
					let osel = olist.find( p => p.value == v);
					// console.log( 'osel', osel )
					fld.html('')
					if( osel && osel.subFields ) {
						setTimeout(function () {
							configOptions(fld, osel.subFields, varObj, filter)
						}, 0)
					}
				})
				let btn = drp.find('button');
				if( o.css ) btn.css(o.css);
				if( o.class ) btn.addClass(o.class);
				if( o.required ) {
					drp.addClass('field_required').prop('required_message', typeof(o.required) == 'string' ? o.required : 'This field is required')
				}				
			}
			else if( o.type == 'file' ) {
				if (o.title) {
					let lab = $('<label for="' + cid + '">' + o.title + '</label>')
					cont.append(lab);
				}
				let div = $('<DIV>').addClass('mb-2');
				function fnameSet( _name ) {
					let [name,ts] = (_name || '').split(':');
					ts = ts ? ( ' <i>('+new Date(ts*1).toLocaleString() + ')</i>') : '';
					fname.html( name + ts);
					if( name > '' ) {
						let bb = $('<b><i class="fa fa-close"></i></b>');
						fname.append( bb )
						bb.css({cursor:'pointer', marginLeft: 5, marginRight: 10 }).on('click', () => {
							oKey(varObj,o.key,'');
							fnameSet('')
						} );
					}
				}
				let fname = $('<span class="frm_file_input">');
				fnameSet(oKey(varObj,o.key));
				div.append( fname );
				cont.append(div);
				let btn = $('<button>'+o.button+'</button>').addClass('btn btn-primary')
				window.uploadButton( btn, o.ext, function(data, n, ts){
					// console.log( d, atob(d) );
					n = (n||'').replace(/:/g, '_');
					if( !ts ) ts = ';'
					fnameSet( n+':'+ts );
					oKey(varObj,o.key,'base64:'+n+':'+ts+':'+data);
					if( o.callback ) o.callback( oKey( varObj, o.key) )
				});
				div.append(btn);
			}
			else if( o.type == 'title' ) {
				let tit = $('<h2>').html( o.title )
				cont.append( tit )
			}
			else if( o.type == 'div' ) {
				let div = $('<div>').html( o.html || '' );
				if( o.class ) div.addClass( o.class );
				if( o.css ) div.css( o.css )
				if( o.id ) div.prop('id', o.id )
				cont.append( div )
			}			
			else if( o.type == 'button' ) {
				let btn = $('<button>').html( o.label ).addClass('btn btn-primary')
				btn.on('click', function(){
					if( o.callback ) o.callback( btn[0], o );
				})
				cont.append( btn )
			}
			else {
				if (o.title) {
					let lab = $('<label for="' + cid + '">' + o.title + '</label>')
					cont.append(lab);
				}
				let inpt = null;
				let oval = oKey(varObj,o.key);
				if( (oval === undefined || oval === null) && (o.default || o.default === 0) ) {
					oval = o.default;
					oKey(varObj, o.key, oval);
				}
				if( o.type == 'textarea' ) {
					inpt = $('<textarea class="mb-4 form-control">').prop('id', cid).val(oval).attr('placeholder', o.placeholder);
				}
				else {
					inpt = $('<input class="mb-4 form-control">').prop('id', cid).attr('type', 'text').val(oval).attr('placeholder', o.placeholder);
					if( o.type.match(/time/) ) {
						inpt.val( time2string( oval, o.type == 'timemilliseconds' ? 3 : 0 ))
					}
				}
				if( o.required ) {
					inpt.addClass('field_required').prop('required_message', typeof(o.required) == 'string' ? o.required : 'This field is required')
				}
				if( o.css ) inpt.css( o.css );
				if( o.type == 'password' ) {
					inpt.attr('type', 'password');
				}
				if( inpt.val().match(/^OBF:/) ) inpt.attr('type','password');
				cont.append(inpt);
				function ckobfuscate() {
					if( inpt.val().trim() == '' && oKey(varObj,o.key+'_obfuscate') ) {
						inpt.val( oKey(varObj,o.key+'_obfuscate') ).attr( 'obfuscated', true )
					}
				}
				inpt.on('change', function () {
					let v = inpt.val();
					if( o.type.match(/time/) ) {
						v = string2time( v );
						oKey(varObj, o.key, v);
						inpt.val(time2string(v,o.type == 'timemilliseconds' ? 3 : 0))
					}
					else {
						try { if (o.numeric) {
							v *= 1;
							if( isNaN(v) ) v = 0;
						} }
						catch (e) { v = 0 }
						oKey(varObj, o.key, v);
						inpt.val(v)
						ckobfuscate();
						// console.log(inpt.val())
					}
					if( o.callback ) o.callback( v );
				}).on('focus', () => {
					inpt[0].select();
				}).on("keydown", () => {
					if (inpt.attr('obfuscated') == 'true') {
						inpt.val('').attr('obfuscated', 'false')
					}
				})
				if (o.type == 'float' || o.type == 'num' || o.type == 'int' || o.type == 'timemilliseconds' || o.type == 'time') {
					o.numeric = true;
					inpt.addClass('config-num')
				}
				ckobfuscate();
			}
			// console.log('oooo', o.key, o.type)
		}
	}, 0)

}

function time2string( t, precision )
{
	if( typeof(t) != 'number' || t == 0 || isNaN(t)) t = 0;
	var m = Math.floor(t/60);
	var h = Math.floor(m/60);
	var s = Math.floor(t);
	var ms = t-s;
	if( precision ) ms = ms.toFixed(precision).substr(1,1000);
	else ms = '';
	// console.log( t, s, ms )
	// if( s < 10 ) return s+ms;
	s = s % 60;
	var ft = s.toString().padStart(2,'0')+ms;
	if( 1 )
	{
		if( m < 10 ) return m+':'+ft;
		m = m % 60;
		ft = m.toString().padStart(2,'0') + ':' + ft;
	}
	if( h )
	{
		if( h < 10 ) return h+':'+ft;
		h = h % 60;
		ft = h.toString().padStart(2,'0') + ':' + ft;
	}
	return ft;
}

function string2time( s ) {
	let [base,prec] = s.toString().split('.');
	// base *= 1;
	prec = ('0.'+prec) * 1;
	if( isNaN(prec) ) prec = 0;
	// console.log( base, prec )

	let tm = base.split(':');
	let time = prec;
	let mults = [1,60,60*60,60*60*24];
	while( tm.length ) {
		let m = mults.shift();
		let t = tm.pop()*1;
		if( isNaN(t) ) t = 0;
		// console.log( 'tm', t, m )
		time += t*m;
	}

	// console.log( time, time2string( time, 3 ) )
	return time;
}

// string2time( '59:57.500' )
// string2time( '59:57.05' )
// string2time( '59:57' )

async function resultCheck( res ) {
	let result = res.data || {};
	if( result.status === 0 ) {
		await myAlertClose();
		await loadingOut();
		let err = [result.value || ''];
		if( result.detail ) err.push( result.detail );
		myAlert('Error', err.join( ', ') );
		return false;
	}
	return true;
}


export default {
	paginator: paginator,
	paletteWheel: paletteWheel,
	booleanList: booleanList,
	optionList: optionList,
	arr2Obj: arr2Obj,
	obj2Arr: obj2Arr,
	arr2Bool: arr2Bool,
	bool2Arr: bool2Arr,
	obj2Vals: obj2Vals,
	vals2Obj: vals2Obj,
	exists: exists,
	ckEmail: ckEmail,
	myAlert: myAlert,
	myAlertClose: myAlertClose,
	myConfirm: myConfirm,
	myInput: myInput,
	smallerText: smallerText,
	formatPreview: formatPreview,
	formatThumb: formatThumb,
	timeZone: timeZone,
	localDateTime: localDateTime,
	timeFromNow: timeFromNow,
	timeFuture: timeFuture,
	makeTaskList: makeTaskList,
	eventOutside: eventOutside,
	eventOutsideEnd: eventOutsideEnd,
	loadThumbnails: loadThumbnails,
	colOptName: colOptName,
	loading: loading,
	progressBar: progressBar,
	loadingOut: loadingOut,
	saveClipboard: saveClipboard,
	dropDown: dropDown,
	itemList: itemList,
	aUnique: aUnique,
	aLast: aLast,
	runAll: runAll,
	undotKeys: undotKeys,
	dotKeys: dotKeys,
	getPresignedImage: getPresignedImage,
	convertSelects: convertSelects,
	selectUpdate: selectUpdate,
	removeInlineErrors: removeInlineErrors,
	inlineError: inlineError,
	expandSection: expandSection,
	collapseSection: collapseSection,
	inputTitles: inputTitles,
	configSection: configSection,
	configOptions: configOptions,
	resultCheck: resultCheck,
	requiredInputs: requiredInputs,
};
